import gsap from 'gsap'

import Component from 'Scripts/classes/Component'

export default class extends Component {
  constructor() {
    super({
      container: '[data-mod = "realisation"]',
      elements: {
        moduleWrapper: '[data-mod = "realisation"] .module__wrapper',
        imgWrapper: '.realisationImg__wrapper',
        moduleItems: '[data-mod = "realisation"] .module__item',
        moduleImgItemsWrapper: '.realisationImg_items',
        moduleImgItems: '.realisationImg_item',
      }
    })

    this.onMouseEnter = this.onMouseEnter.bind(this)
    this.onMouseLeave = this.onMouseLeave.bind(this)

    //Methods
    this.length = this.elements.moduleItems ? this.elements.moduleItems.length : 0
    if (this.length > 0 && !document.documentElement.classList.contains('isTouchDevice')) {
      this.init()
      this.addEventsListeners()
    }
  }

  enabled() {
    return this.elements.imgWrapper.classList.contains('active')
  }

  enable() {
    if (!this.animating) {
      this.animating = true
      this.elements.imgWrapper.classList.add('active')
      gsap.to(this.elements.imgWrapper, {      
        autoAlpha: 1,
        onComplete: () => { this.animating = false }
      })
    }
  }

  animate(index) {
    if (!this.enabled()) {

      gsap.set(this.elements.moduleImgItems[index], {
        autoAlpha: 1,
        // y: 0
      })

    } else {
     
      this.elements.moduleImgItems.forEach(elm => {        
        gsap.to(elm, {
          autoAlpha: 0,
          zIndex : 0,
          duration: 0.2, 
          // y : '100%'
        })
      })

      gsap.to(this.elements.moduleImgItems[index],{
        autoAlpha: 1,
        // y: 0,
        zIndex : 1,
        duration: 0.5,                
        ease: 'Power2.easeInOut',
        overwrite: true,
      })

    }

  }

  async onItemMouseEnter(index) {
    this.animate(index)
  
  }

  onMouseEnter() {
    // console.log('onMouseEnter')
    this.elements.imgWrapper.classList.add('active')
    gsap.to(this.elements.imgWrapper, {
      autoAlpha: 1,
      duration: 0.5
    })
  }

  onMouseLeave() {
    // console.log('onMouseLeave')
    this.elements.imgWrapper.classList.remove('active')    
    gsap.set(this.elements.imgWrapper, { autoAlpha: 0, overwrite : true})
  }

  addEventsListeners() {
    this.removeEventsListeners()
   
    this.elements.moduleItems.forEach((item, index) => item.addEventListener('mouseenter', _ => this.onItemMouseEnter(index), true))
    this.elements.moduleWrapper.addEventListener('mouseleave', this.onMouseLeave, false)
    this.elements.moduleWrapper.addEventListener('mouseenter', this.onMouseEnter, false)
  }

  removeEventsListeners() {
    this.elements.moduleWrapper.removeEventListener('mouseenter', this.onMouseEnter, false)
    this.elements.moduleWrapper.removeEventListener('mouseleave', this.onMouseLeave, false)

  }

  init() {

    this.bounds = {
      width: this.elements.imgWrapper.offsetWidth,
      height: this.elements.imgWrapper.offsetHeight
    }
    //
    gsap.set(this.elements.imgWrapper, { autoAlpha: 0 })
    gsap.set(this.elements.moduleImgItems, { autoAlpha: 0 })
    //
    this.elements.moduleWrapper.addEventListener('mousemove', this.onMouseMoveEvent.bind(this))
  }

  onMouseMoveEvent(e) {
    e.preventDefault()
    gsap.to(this.elements.imgWrapper, {
      y: e.y - this.bounds.height / 2,
      // duration: 1,
    })
  }

}